import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	// Actions
	copyTooltipHoverNonfinal: {
		defaultMessage: 'Copy {itemToCopy}',
		id: 'applinks.administration.ui.common.fields.copy-button.copy-tooltip-hover-nonfinal',
		description: 'Tooltip shown on hover, informs user that clicking will copy content',
	},
	copyTooltipFeedbackNonfinal: {
		defaultMessage: 'Copied',
		id: 'applinks.administration.ui.common.fields.copy-button.copy-tooltip-feedback-nonfinal',
		description: 'Feedback message shown in tooltip after content is copied',
	},
});
